<template>
  <!-- 收货信息 -->
  <card class="wrapper">
    <AdminTitle title="收货信息" size="15px" bottom="5px"/>

    <div class="wrapper-address special-card">
      <div>
        <span class="label">联系人：</span>
        <span class="value">{{ orderAddress?.contactName}}</span>
        <span class="value">{{ orderAddress?.contactMobile}}</span>
      </div>
      <div>
        <span class="label">联系地址：</span>
        <span class="value">
          {{ orderAddress?.province + orderAddress?.city + orderAddress?.district + orderAddress?.detail }}
        </span>
        <span
          class="el-icon-edit"
          @click="editAddress"
          v-show="status < 3 && isShowBtn(AUTH_BTN.order_list_detail_edit_address)"
        >
          编辑
        </span>
      </div>
    </div>

    <!-- 编辑收货地址弹窗 -->
    <el-dialog
      title="编辑收货地址"
      :visible.sync="addressDialogVisible"
      width="450px"
      :show-close="true"
    >
      <el-form ref="formUser" :model="addressFormData" label-width="80px">
        <el-form-item label="联系人">
          <el-input
            style="width: 300px"
            v-model="addressFormData.contactName"
            size="small"
          />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            style="width: 300px"
            v-model="addressFormData.contactMobile"
            size="small"
          />
        </el-form-item>
        <el-form-item label="所在地区">
          <AreaSelector
            style="width: 300px"
            size="small"
            v-model="addressFormData.regionIdList"
          />
        </el-form-item>
        <el-form-item label="详细地址">
          <el-input
            style="width: 300px"
            type="textarea"
            v-model="addressFormData.detail"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addressDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveAddress" size="small">保 存</el-button>
      </div>
    </el-dialog>
  </card>
</template>

<script>
import { updateOrderAddressAPI } from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import AreaSelector from "@/components/area-selector/index.vue";

export default {
  name: "Address",
  mixins: [authBtnMixin],
  components: { AreaSelector },
  props: {
    orderAddress: {
      type: Object,
      default: () => {},
    },
    status: {
      type: [Number, String],
    },
    flag: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      addressDialogVisible: false,
      innerVisible: false,
      addressFormData: {
        orderNo: this.$route.params.id,
        contactName: "",
        contactMobile: "",
        contactEmail: "",
        detail: "",
        regionIdList: [],
      },
      address: {},
    };
  },

  watch: {
    orderAddress: {
      handler(newV, oldV) {
        this.address = { ...this.orderAddress };
      },
    },
  },

  computed: {
    tableData() {
      return this.orderAddress ? [this.orderAddress] : [];
    },
  },

  methods: {
    // 编辑收件地址
    editAddress() {
      this.address = { ...this.orderAddress };
      this.addressDialogVisible = true;
      const { contactName, contactMobile, contactEmail, detail, regionIdList } = this.orderAddress;

      this.addressFormData = {
        orderNo: this.$route.params.id,
        contactName,
        contactMobile,
        contactEmail,
        detail,
        regionIdList: regionIdList ?? [],
      };
    },

    // 保存地址
    saveAddress() {
      updateOrderAddressAPI({
        ...this.addressFormData,
        districtId: this.addressFormData.regionIdList[2],
      }).then(() => {
        this.$emit("update:flag", false);
        this.$emit("updateDetail");
        this.$message.success("更新成功");
        this.addressDialogVisible = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  width: 100%;
  border-color: transparent;
  margin-top: 5px;
  border-radius: 16px;
  color: #222222;

  .wrapper-address {
    border-radius: 16px;
    padding: 15px;
  }

  .special-card {
    background: #f7f8fa;
    line-height: 35px;
    color: #222222;
    position: relative;

    .value {
      margin-left: 15px;
      min-width: 80px;
      display: inline-block;
      font-weight: 700;
    }

    .label {
      text-align: right;
      min-width: 80px;
      display: inline-block;
    }

    .el-icon-edit {
      margin-left: 20px;
      cursor: pointer;
      color: #4badf8;
    }
  }
}
</style>
